/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormControl } from 'react-bootstrap';
import isValid from 'date-fns/is_valid';
import setMinutes from 'date-fns/set_minutes';
import format from 'date-fns/format';
import ShowIf from '@/components/ShowIf';
import MomentSelect from '@/components/MomentSelect';
import styles from './styles.scss';

const propTypes = {
  onSelect: PropTypes.func.isRequired,
  date: PropTypes.instanceOf(Date),
};

const defaultProps = {
  date: new Date(),
};

class TimePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: setMinutes(props.date, '0'),
    };
    this.id = `timepiacker_${Number(Math.random() * 10000).toFixed(0)}`;
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputBlur = this.handleInputBlur.bind(this);
    this.handleOnSelect = this.handleOnSelect.bind(this);
    this.clickToBlur = this.clickToBlur.bind(this);
    this.inputChanged = false;
  }

  componentDidMount() {
    $('body').click(this.clickToBlur);
  }

  componentWillReceiveProps(nextProps) {
    const { date } = nextProps;
    if (!_.isEqual(date, this.props.date)) {
      this.setState({ date });
    }
  }

  componentWillUnmount() {
    $('body').off('click', this.clickToBlur);
  }

  clickToBlur(e) {
    let blurred = true;
    $(e.target).parents().each((idx, elem) => {
      if (elem.id === this.id) {
        blurred = false;
      }
    });
    if (blurred) {
      this.setState({ showOverlay: false });
      this.props.onSelect(this.state.date);
    }
  }

  handleInputFocus() {
    this.setState({ showOverlay: true });
  }

  handleInputChange(e) {
    const value = e.target.value.trim();
    this.setState({ value });
    const date = new Date(value);
    if (isValid(date)) {
      this.inputChanged = true;
      this.setState({ date });
    }
  }

  handleInputBlur() {
    if (this.inputChanged) {
      const { onSelect } = this.props;
      const { date } = this.state;
      this.inputChanged = false;
      onSelect(date);
    }
  }

  handleOnSelect(date) {
    this.setState({ date });
  }

  render() {
    const { showOverlay = false, date } = this.state;

    return (
      <div id={this.id} styleName="timepicker">
        <FormControl
          bsClass="aisz-form-control-f"
          type="text"
          value={format(date, 'HH:mm')}
          onFocus={this.handleInputFocus}
          onBlur={this.handleInputBlur}
          onChange={this.handleInputChange}
        />
        <ShowIf if={showOverlay}>
          <div className="overlay">
            <div styleName="container">
              <MomentSelect
                date={date}
                onSelect={this.handleOnSelect}
              />
            </div>
          </div>
        </ShowIf>
      </div>
    );
  }
}

TimePicker.propTypes = propTypes;
TimePicker.defaultProps = defaultProps;

export default CSSModules(TimePicker, styles, { allowMultiple: true });




// WEBPACK FOOTER //
// ./src/components/TimePicker/index.jsx